import e from "loadjs";
import n from "react-dom";
import a from "react-dom/server";
import o from "uuid/v1";
import t, { useState as r, useEffect as i, useReducer as d, useContext as l, useRef as c } from "react";

var s = {
  lat: 40.7128,
  lng: -74.006
},
    u = [{
  lat: 40.718,
  lng: -74.006
}, {
  lat: 40.718,
  lng: -74.01
}, {
  lat: 40.7138,
  lng: -74.001
}, {
  lat: 40.7128,
  lng: -74.005
}],
    m = {
  east: -74,
  west: -74.006,
  north: 40.718,
  south: 40.714
},
    p = {
  center: s,
  radius: 200
},
    g = {},
    v = {
  url: "https://placehold.it/256x256",
  bounds: m
},
    h = {
  data: [{
    lat: 40.718,
    lng: -74.006
  }, {
    lat: 40.712,
    lng: -74.01
  }],
  radius: 100
},
    f = {
  content: "Hello",
  position: s
},
    y = {
  url: "http://api.flickr.com/services/feeds/geo/?g=322338@N20&lang=en-us&format=feed-georss"
},
    b = {
  center: s,
  zoom: 14
},
    C = {
  height: "100%",
  width: "100%"
},
    j = {
  position: s
},
    w = {
  paths: u
},
    O = {
  path: u
},
    k = {
  bounds: m
},
    _ = {
  bounds: m
},
    M = {
  bounds: m
},
    N = {
  position: s
},
    P = ["drawing", "geometry", "places", "visualization"],
    E = function E(n) {
  var a = n.apiKey,
      o = n.libraryParam,
      t = n.languageParam,
      d = n.regionParam,
      l = r(!1),
      c = l[0],
      s = l[1];
  return i(function () {
    if ("undefined" != typeof document) {
      var n = "https://maps.googleapis.com/maps/api/js?key=" + a + o + t + d;
      e.isDefined("gmap") || e(n, "gmap"), e.ready("gmap", {
        success: function success() {
          s(!0);
        },
        error: function error() {
          e.reset(), console.error("Unable to fetch Google Map sdk");
        }
      });
    }
  }, []), c;
},
    D = function D(e, n) {
  i(function () {
    if (void 0 !== e) {
      var a = [];
      return n.forEach(function (n) {
        n.handler && a.push(google.maps.event.addListener(e, n.name, n.handler));
      }), function () {
        a.forEach(function (e) {
          return e.remove();
        });
      };
    }
  }, [e, n]);
},
    S = function S(e, n, a, o) {
  i(function () {
    void 0 !== e && void 0 !== n && JSON.stringify(n) !== a && (e.setOptions(n), o(JSON.stringify(n)));
  }, [e, n]);
},
    x = function x() {
  return {
    map: void 0,
    objects: new Map(),
    places: void 0
  };
},
    T = t.createContext({
  state: void 0,
  dispatch: void 0
}),
    L = function L(e, n) {
  switch (n.type) {
    case "reset":
      return x();

    case "init_map":
      if (void 0 === n.map) throw new Error("You should specify a map instance");
      if (void 0 !== e.map) throw new Error("There can only be one map instance in a context");
      return Object.assign({}, e, {
        map: n.map,
        places: n.places
      });

    case "add_object":
      if (void 0 === n.object) throw new Error("You should specify an object instance");
      if (void 0 === n.id) throw new Error("You should specify an id");
      if (e.objects.has(n.id)) throw new Error("The id has already been taken");
      return e.objects.set(n.id, n.object), e;

    case "remove_object":
      if (void 0 === n.id) throw new Error("You should specify an id");
      var a = e.objects.get(n.id);
      if (void 0 === a) throw new Error("There is no object with the given id");
      return a.setMap && a.setMap(null), e.objects.delete(n.id), e;

    default:
      return e;
  }
},
    I = function I(e) {
  var n = e.children,
      a = d(L, x());
  return t.createElement(t.Fragment, null, t.createElement(T.Provider, {
    value: {
      state: a[0],
      dispatch: a[1]
    }
  }, n));
},
    J = T.Consumer,
    R = function R(e) {
  var n = e.id,
      d = e.opts;
  void 0 === d && (d = M);

  var c = e.onPlaceChanged,
      s = e.bindingPosition,
      u = function (e, n) {
    var a = {};

    for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && -1 === n.indexOf(o) && (a[o] = e[o]);
    }

    return a;
  }(e, ["id", "opts", "onPlaceChanged", "bindingPosition"]),
      m = l(T),
      p = m.state,
      g = m.dispatch,
      v = r(""),
      h = v[0],
      f = v[1],
      y = r(void 0),
      b = y[0],
      C = y[1],
      j = r(n || "autocomplete-" + o())[0],
      w = r(document.createRange().createContextualFragment(a.renderToString(t.createElement("input", Object.assign({
    id: j
  }, u)))).firstElementChild)[0],
      O = r(s),
      k = O[0],
      _ = O[1];

  return i(function () {
    if (void 0 !== p.map && void 0 !== p.places) {
      var e = s ? w : document.getElementById(j),
          n = new google.maps.places.Autocomplete(e, d);

      if (C(n), function (e) {
        g({
          type: "add_object",
          object: e,
          id: j
        });
      }(n), f(JSON.stringify(d)), s) {
        if (s !== k) {
          var a = p.map.controls[google.maps.ControlPosition[k]],
              o = a.getArray();
          a.removeAt(o.findIndex(function (e) {
            return e === w;
          })), _(s);
        }

        p.map.controls[google.maps.ControlPosition[s]].push(e);
      }

      return function () {
        return g({
          type: "remove_object",
          id: j
        });
      };
    }
  }, [p.places, s]), D(b, [{
    name: "place_changed",
    handler: c
  }]), S(b, d, h, f), s ? null : t.createElement("input", Object.assign({
    id: j
  }, u));
};

R.displayName = "Autocomplete";

var B = function B(e) {
  return t.createElement(R, Object.assign({}, e));
};

B.displayName = "Autocomplete";

var A = function A(e) {
  return t.createElement(R, Object.assign({}, e));
};

A.displayName = "StandaloneAutocomplete";

var V = function V(e) {
  var n = e.type,
      a = e.opts,
      o = n + "-layer",
      t = l(T),
      d = t.state,
      c = t.dispatch,
      s = r(void 0),
      u = s[0],
      m = s[1];
  return i(function () {
    if (void 0 !== d.map) {
      var e = {
        bicycling: google.maps.BicyclingLayer,
        traffic: google.maps.TrafficLayer,
        transit: google.maps.TransitLayer
      },
          t = "traffic" === n ? new e[n](a) : new e[n]();
      return t.setMap(d.map), m(t), function (e) {
        c({
          type: "add_object",
          object: e,
          id: o
        });
      }(t), function () {
        return c({
          type: "remove_object",
          id: o
        });
      };
    }
  }, [d.map]), i(function () {
    "traffic" === n && void 0 !== a && void 0 !== u && u.setOptions(a);
  }, [a]), null;
};

V.displayName = "layer";

var z = function z(e) {
  return t.createElement(V, {
    type: "bicycling"
  });
};

z.displayName = "BicyclingLayer";

var H = function H(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = p);
  var t = e.onCenterChanged,
      d = e.onClick,
      c = e.onDoubleClick,
      s = e.onDrag,
      u = e.onDragEnd,
      m = e.onDragStart,
      g = e.onMouseDown,
      v = e.onMouseOut,
      h = e.onMouseOver,
      f = e.onMouseUp,
      y = e.onRadiusChanged,
      b = e.onRightClick,
      C = l(T),
      j = C.state,
      w = C.dispatch,
      O = r(""),
      k = O[0],
      _ = O[1],
      M = r(void 0),
      N = M[0],
      P = M[1],
      E = r(n || "circle-" + o())[0];
  return i(function () {
    if (void 0 !== j.map) {
      var e = new google.maps.Circle(Object.assign({}, a, {
        map: j.map
      }));
      return P(e), _(JSON.stringify(a)), function (e) {
        w({
          type: "add_object",
          object: e,
          id: E
        });
      }(e), function () {
        return w({
          type: "remove_object",
          id: E
        });
      };
    }
  }, [j.map]), D(N, [{
    name: "center_changed",
    handler: t
  }, {
    name: "click",
    handler: d
  }, {
    name: "dblclick",
    handler: c
  }, {
    name: "drag",
    handler: s
  }, {
    name: "dragend",
    handler: u
  }, {
    name: "dragstart",
    handler: m
  }, {
    name: "mousedown",
    handler: g
  }, {
    name: "mouseout",
    handler: v
  }, {
    name: "mouseover",
    handler: h
  }, {
    name: "mouseup",
    handler: f
  }, {
    name: "radius_changed",
    handler: y
  }, {
    name: "rightclick",
    handler: b
  }]), S(N, a, k, _), null;
};

H.displayName = "Circle";

var F = function F(e) {
  var a = e.bindingPosition;
  void 0 === a && (a = "RIGHT_TOP");
  var o = e.children;
  if ("undefined" == typeof document) return null;
  var t = l(T).state,
      d = r(document.createElement("div"))[0],
      c = r(a),
      s = c[0],
      u = c[1];
  return i(function () {
    if (void 0 !== t.map) {
      if (a !== s) {
        var e = t.map.controls[google.maps.ControlPosition[s]],
            n = e.getArray();
        e.removeAt(n.findIndex(function (e) {
          return e === d;
        })), u(a);
      }

      t.map.controls[google.maps.ControlPosition[a]].push(d);
    }
  }, [t.map, a]), n.createPortal(o, d);
};

F.displayName = "CustomControl";

var U = function U(e) {
  var n = e.opts;
  void 0 === n && (n = g);

  var a = e.onCircleComplete,
      o = e.onMarkerComplete,
      t = e.onOverlayComplete,
      d = e.onPolygonComplete,
      s = e.onPolylineComplete,
      u = e.onRectangleComplete,
      m = l(T),
      p = m.state,
      v = m.dispatch,
      h = r(""),
      f = h[0],
      y = h[1],
      b = r(void 0),
      C = b[0],
      j = b[1],
      w = r(0),
      O = w[0],
      k = w[1],
      _ = c(0);

  return _.current = O, i(function () {
    if (void 0 !== p.map) {
      var e = new google.maps.drawing.DrawingManager(Object.assign({}, n, {
        map: p.map
      }));
      return j(e), y(JSON.stringify(n)), function (e) {
        v({
          type: "add_object",
          object: e,
          id: "drawing-manager"
        });
      }(e), function () {
        return function () {
          for (var e = 0; e < _.current; e++) {
            v({
              type: "remove_object",
              id: "drawing-manager-" + e
            });
          }
        }(), void v({
          type: "remove_object",
          id: "drawing-manager"
        });
      };
    }
  }, [p.map]), D(C, [{
    name: "circlecomplete",
    handler: a
  }, {
    name: "markercomplete",
    handler: o
  }, {
    name: "overlaycomplete",
    handler: t
  }, {
    name: "overlaycomplete",
    handler: function handler(e) {
      return n = e.overlay, k(function (e) {
        return v({
          type: "add_object",
          object: n,
          id: "drawing-manager-" + e
        }), e + 1;
      });
      var n;
    }
  }, {
    name: "polygoncomplete",
    handler: d
  }, {
    name: "polylinecomplete",
    handler: s
  }, {
    name: "rectanglecomplete",
    handler: u
  }]), S(C, n, f, y), null;
};

U.displayName = "DrawingManager";

var G = function G(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = v);

  var t = e.onClick,
      d = e.onDoubleClick,
      c = l(T),
      s = c.state,
      u = c.dispatch,
      m = r(void 0),
      p = m[0],
      g = m[1],
      h = r(n || "ground-overlay-" + o())[0],
      f = r(void 0),
      y = f[0],
      b = f[1],
      C = r(!0),
      j = C[0],
      w = C[1],
      O = function O() {
    return u({
      type: "remove_object",
      id: h
    });
  },
      k = function k() {
    var e = new google.maps.GroundOverlay(a.url, a.bounds, {
      clickable: a.clickable,
      opacity: a.opacity,
      map: s.map
    });
    g(e), b(a.bounds), w(void 0 === a.clickable || a.clickable), function (e) {
      u({
        type: "add_object",
        object: e,
        id: h
      });
    }(e);
  };

  return i(function () {
    if (void 0 !== s.map) return k(), function () {
      return O();
    };
  }, [s.map]), D(p, [{
    name: "click",
    handler: t
  }, {
    name: "dblclick",
    handler: d
  }]), i(function () {
    void 0 !== p && a.opacity && a.opacity !== p.getOpacity() && p.setOpacity(a.opacity);
  }, [a.opacity]), i(function () {
    if (void 0 !== s.map && void 0 !== p) {
      var e = void 0 === a.clickable || a.clickable;
      a.url === p.getUrl() && Object.is(JSON.stringify(a.bounds), JSON.stringify(y)) && e === j || (O(), k());
    }
  }, [a.url, a.bounds, a.clickable]), null;
};

G.displayName = "GroundOverlay";

var K = function K() {
  return window.hasOwnProperty("google") && google.maps && google.maps.visualization;
},
    Y = function Y(e) {
  return function (n) {
    var a = r(!1),
        o = a[0],
        d = a[1];
    return i(function () {
      if (K()) d(!0);else var e = setInterval(function () {
        K() && (d(!0), clearInterval(e));
      }, 500);
    }, []), t.createElement(t.Fragment, null, o ? t.createElement(e, Object.assign({}, n)) : null);
  };
},
    Z = function Z(e) {
  return {
    location: new google.maps.LatLng(e.lat, e.lng),
    weight: e.weight || 1
  };
},
    W = Y(function (e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = h);
  var t = l(T),
      d = t.state,
      c = t.dispatch,
      s = r(void 0),
      u = s[0],
      m = s[1],
      p = r(n || "heat-map-" + o())[0];
  return i(function () {
    if (void 0 !== d.map) {
      var e = new google.maps.visualization.HeatmapLayer(Object.assign({}, a, {
        data: a.data.map(function (e) {
          return Z(e);
        }),
        map: d.map
      }));
      return m(e), c({
        type: "add_object",
        object: e,
        id: p
      }), function () {
        return c({
          type: "remove_object",
          id: p
        });
      };
    }
  }, [d.map]), i(function () {
    void 0 !== u && void 0 !== a.data && u.setData(a.data.map(function (e) {
      return Z(e);
    }));
  }, [a.data]), null;
}),
    q = function q(e) {
  var a = e.anchorId,
      o = e.opts;
  void 0 === o && (o = f);
  var t = e.visible,
      d = e.children,
      c = e.onCloseClick,
      s = e.onContentChanged,
      u = e.onDOMReady,
      m = e.onPositionChanged,
      p = e.onZIndexChanged;
  if ("undefined" == typeof document) return null;
  var g = l(T).state,
      v = r(void 0),
      h = v[0],
      y = v[1],
      b = r(document.createElement("div"))[0];
  return i(function () {
    if (void 0 !== g.map) {
      var e = new google.maps.InfoWindow(Object.assign({}, o, {
        content: d ? b : o.content
      }));
      y(e);
      var n = a ? g.objects.get(a) : void 0;
      return t ? e.open(g.map, n) : e.close(), function () {
        return e.close();
      };
    }
  }, [g.map, t, a && g.objects.get(a)]), D(h, [{
    name: "closeclick",
    handler: c
  }, {
    name: "content_changed",
    handler: s
  }, {
    name: "domready",
    handler: u
  }, {
    name: "position_changed",
    handler: m
  }, {
    name: "zindex_changed",
    handler: p
  }]), i(function () {
    void 0 !== h && h.setOptions(Object.assign({}, o, {
      content: d ? b : o.content
    }));
  }, [o]), n.createPortal(d, b);
};

q.displayName = "InfoWindow";

var Q = function Q(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = y);
  var t = e.onClick,
      d = e.onDefaultViewportChanged,
      c = e.onStatusChanged,
      s = l(T),
      u = s.state,
      m = s.dispatch,
      p = r(""),
      g = p[0],
      v = p[1],
      h = r(void 0),
      f = h[0],
      b = h[1],
      C = r(n || "kml-layer-" + o())[0];
  return i(function () {
    if (void 0 !== u.map) {
      var e = new google.maps.KmlLayer(Object.assign({}, a, {
        map: u.map
      }));
      return b(e), v(JSON.stringify(a)), function (e) {
        m({
          type: "add_object",
          object: e,
          id: C
        });
      }(e), function () {
        return m({
          type: "remove_object",
          id: C
        });
      };
    }
  }, [u.map]), D(f, [{
    name: "click",
    handler: t
  }, {
    name: "defaultviewport_changed",
    handler: d
  }, {
    name: "status_changed",
    handler: c
  }]), S(f, a, g, v), null;
};

Q.displayName = "KmlLayer";

var X = function X(e) {
  var n = e.apiKey;
  void 0 === n && (n = "");
  var a = e.language,
      d = e.region,
      c = e.className,
      s = e.style;
  void 0 === s && (s = C);
  var u = e.opts;
  void 0 === u && (u = b);
  var m = e.useDrawing;
  void 0 === m && (m = !1);
  var p = e.useGeometry;
  void 0 === p && (p = !1);
  var g = e.usePlaces;
  void 0 === g && (g = !1);
  var v = e.useVisualization;
  void 0 === v && (v = !1);
  var h = e.LoadedComponent;
  void 0 === h && (h = null);
  var f = e.LoadingComponent;
  void 0 === f && (f = t.createElement("p", null, "Loading..."));

  var y = e.onBoundsChanged,
      j = e.onCenterChanged,
      w = e.onClick,
      O = e.onDoubleClick,
      k = e.onDrag,
      _ = e.onDragEnd,
      M = e.onDragStart,
      N = e.onHeadingChanged,
      x = e.onIdle,
      L = e.onMapTypeIdChanged,
      I = e.onMouseMove,
      J = e.onMouseOut,
      R = e.onMouseOver,
      B = e.onProjectionChanged,
      A = e.onRightClick,
      V = e.onTilesLoaded,
      z = e.onTiltChanged,
      H = e.onZoomChanged,
      F = l(T).dispatch,
      U = r(""),
      G = U[0],
      K = U[1],
      Y = r(void 0),
      Z = Y[0],
      W = Y[1],
      q = r("map-" + o())[0],
      Q = function Q(e, n) {
    return F({
      type: "init_map",
      map: e,
      places: n
    });
  },
      X = {
    drawing: m,
    geometry: p,
    places: g,
    visualization: v
  },
      $ = P.filter(function (e) {
    return X[e];
  }).join(","),
      ee = E({
    apiKey: n,
    libraryParam: "" === $ ? "" : "&libraries=" + $,
    languageParam: void 0 === a ? "" : "&language=" + a,
    regionParam: void 0 === d ? "" : "&region=" + d
  });

  return i(function () {
    if (ee) {
      var e = JSON.stringify(u),
          n = new google.maps.Map(document.getElementById(q), JSON.parse(e));

      if (W(n), K(e), g) {
        var a = new google.maps.places.PlacesService(n);
        Q(n, a);
      } else Q(n);

      return function () {
        return F({
          type: "reset"
        });
      };
    }
  }, [ee]), D(Z, [{
    name: "bounds_changed",
    handler: y
  }, {
    name: "center_changed",
    handler: j
  }, {
    name: "click",
    handler: w
  }, {
    name: "dblclick",
    handler: O
  }, {
    name: "drag",
    handler: k
  }, {
    name: "dragend",
    handler: _
  }, {
    name: "dragstart",
    handler: M
  }, {
    name: "heading_changed",
    handler: N
  }, {
    name: "idle",
    handler: x
  }, {
    name: "maptypeid_changed",
    handler: L
  }, {
    name: "mousemove",
    handler: I
  }, {
    name: "mouseout",
    handler: J
  }, {
    name: "mouseover",
    handler: R
  }, {
    name: "projection_changed",
    handler: B
  }, {
    name: "rightclick",
    handler: A
  }, {
    name: "tilesloaded",
    handler: V
  }, {
    name: "tilt_changed",
    handler: z
  }, {
    name: "zoom_changed",
    handler: H
  }]), S(Z, u, G, K), t.createElement(t.Fragment, null, ee ? h : f, "undefined" != typeof document ? t.createElement("div", {
    id: q,
    style: s,
    className: c
  }) : null);
};

X.displayName = "MapBox";

var $ = function $(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = j);
  var t = e.onAnimationChanged,
      d = e.onClick,
      c = e.onClickableChanged,
      s = e.onCursorChanged,
      u = e.onDoubleClick,
      m = e.onDrag,
      p = e.onDragEnd,
      g = e.onDragStart,
      v = e.onDraggableChanged,
      h = e.onFlatChanged,
      f = e.onIconChanged,
      y = e.onMouseDown,
      b = e.onMouseOut,
      C = e.onMouseOver,
      w = e.onMouseUp,
      O = e.onPositionChanged,
      k = e.onRightClick,
      _ = e.onShapeChanged,
      M = e.onTitleChanged,
      N = e.onVisibleChanged,
      P = e.onZIndexChanged,
      E = l(T),
      x = E.state,
      L = E.dispatch,
      I = r(""),
      J = I[0],
      R = I[1],
      B = r(void 0),
      A = B[0],
      V = B[1],
      z = r(n || "marker-" + o())[0];
  return i(function () {
    if (void 0 !== x.map) {
      var e = new google.maps.Marker(Object.assign({}, a, {
        map: x.map
      }));
      return V(e), R(JSON.stringify(a)), function (e) {
        L({
          type: "add_object",
          object: e,
          id: z
        });
      }(e), function () {
        return L({
          type: "remove_object",
          id: z
        });
      };
    }
  }, [x.map]), D(A, [{
    name: "animation_changed",
    handler: t
  }, {
    name: "click",
    handler: d
  }, {
    name: "clickable_changed",
    handler: c
  }, {
    name: "cursor_changed",
    handler: s
  }, {
    name: "dblclick",
    handler: u
  }, {
    name: "drag",
    handler: m
  }, {
    name: "dragend",
    handler: p
  }, {
    name: "draggable_changed",
    handler: v
  }, {
    name: "dragstart",
    handler: g
  }, {
    name: "flat_changed",
    handler: h
  }, {
    name: "icon_changed",
    handler: f
  }, {
    name: "mousedown",
    handler: y
  }, {
    name: "mouseout",
    handler: b
  }, {
    name: "mouseover",
    handler: C
  }, {
    name: "mouseup",
    handler: w
  }, {
    name: "position_changed",
    handler: O
  }, {
    name: "rightclick",
    handler: k
  }, {
    name: "shape_changed",
    handler: _
  }, {
    name: "title_changed",
    handler: M
  }, {
    name: "visible_changed",
    handler: N
  }, {
    name: "zindex_changed",
    handler: P
  }]), S(A, a, J, R), null;
};

$.displayName = "Marker";

var ee = function ee(e) {
  var a = e.pane;
  void 0 === a && (a = "overlayMouseTarget");
  var o = e.position;
  void 0 === o && (o = s);
  var t = e.children,
      d = e.onClick,
      c = e.onDoubleClick,
      u = e.onMouseDown,
      m = e.onMouseOut,
      p = e.onMouseOver,
      g = e.onMouseUp,
      v = e.onTouchEnd,
      h = e.onTouchStart,
      f = e.disableMapHits;
  void 0 === f && (f = !1);
  var y = e.disableMapHitsAndGestures;
  if (void 0 === y && (y = !1), "undefined" == typeof document) return null;
  var b = l(T).state,
      C = r(document.createElement("div"))[0],
      j = r(void 0),
      w = j[0],
      O = j[1];
  return i(function () {
    if (void 0 !== b.map) {
      var e = new google.maps.OverlayView();
      return e.onAdd = function () {
        C.style.position = "absolute", C.onclick = d || null, C.ondblclick = c || null, C.onmousedown = u || null, C.onmouseover = p || null, C.onmouseout = m || null, C.onmouseup = g || null, C.ontouchend = v || null, C.ontouchstart = h || null, y ? google.maps.OverlayView.preventMapHitsAndGesturesFrom(C) : f && google.maps.OverlayView.preventMapHitsFrom(C), e.getPanes()[a].appendChild(C);
      }, e.onRemove = function () {
        C.parentNode && C.parentNode.removeChild(C);
      }, e.setMap(b.map), O(e), function () {
        return e.setMap(null);
      };
    }
  }, [b.map]), i(function () {
    void 0 !== w && (w.setMap(null), w.draw = function () {
      var e = w.getProjection().fromLatLngToDivPixel(new google.maps.LatLng(o.lat, o.lng));
      C.style.left = JSON.stringify(e.x) + "px", C.style.top = JSON.stringify(e.y) + "px";
    }, w.setMap(b.map));
  }, [w, o]), n.createPortal(t, C);
};

ee.displayName = "OverlayView";

var ne = function ne(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = w);
  var t = e.onClick,
      d = e.onDoubleClick,
      c = e.onDrag,
      s = e.onDragEnd,
      u = e.onDragStart,
      m = e.onMouseDown,
      p = e.onMouseOut,
      g = e.onMouseOver,
      v = e.onMouseUp,
      h = e.onRightClick,
      f = l(T),
      y = f.state,
      b = f.dispatch,
      C = r(""),
      j = C[0],
      O = C[1],
      k = r(void 0),
      _ = k[0],
      M = k[1],
      N = r(n || "polygon-" + o())[0];
  return i(function () {
    if (void 0 !== y.map) {
      var e = new google.maps.Polygon(Object.assign({}, a, {
        map: y.map
      }));
      return M(e), O(JSON.stringify(a)), function (e) {
        b({
          type: "add_object",
          object: e,
          id: N
        });
      }(e), function () {
        return b({
          type: "remove_object",
          id: N
        });
      };
    }
  }, [y.map]), D(_, [{
    name: "click",
    handler: t
  }, {
    name: "dblclick",
    handler: d
  }, {
    name: "drag",
    handler: c
  }, {
    name: "dragend",
    handler: s
  }, {
    name: "dragstart",
    handler: u
  }, {
    name: "mousedown",
    handler: m
  }, {
    name: "mouseout",
    handler: p
  }, {
    name: "mouseover",
    handler: g
  }, {
    name: "mouseup",
    handler: v
  }, {
    name: "rightclick",
    handler: h
  }]), S(_, a, j, O), null;
};

ne.displayName = "Polygon";

var ae = function ae(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = O);
  var t = e.onClick,
      d = e.onDoubleClick,
      c = e.onDrag,
      s = e.onDragEnd,
      u = e.onDragStart,
      m = e.onMouseDown,
      p = e.onMouseOut,
      g = e.onMouseOver,
      v = e.onMouseUp,
      h = e.onRightClick,
      f = l(T),
      y = f.state,
      b = f.dispatch,
      C = r(""),
      j = C[0],
      w = C[1],
      k = r(void 0),
      _ = k[0],
      M = k[1],
      N = r(n || "polyline-" + o())[0];
  return i(function () {
    if (void 0 !== y.map) {
      var e = new google.maps.Polyline(Object.assign({}, a, {
        map: y.map
      }));
      return M(e), w(JSON.stringify(a)), function (e) {
        b({
          type: "add_object",
          object: e,
          id: N
        });
      }(e), function () {
        return b({
          type: "remove_object",
          id: N
        });
      };
    }
  }, [y.map]), D(_, [{
    name: "click",
    handler: t
  }, {
    name: "dblclick",
    handler: d
  }, {
    name: "drag",
    handler: c
  }, {
    name: "dragend",
    handler: s
  }, {
    name: "dragstart",
    handler: u
  }, {
    name: "mousedown",
    handler: m
  }, {
    name: "mouseout",
    handler: p
  }, {
    name: "mouseover",
    handler: g
  }, {
    name: "mouseup",
    handler: v
  }, {
    name: "rightclick",
    handler: h
  }]), S(_, a, j, w), null;
};

ae.displayName = "Polyline";

var oe = function oe(e) {
  var n = e.id,
      a = e.opts;
  void 0 === a && (a = k);

  var t = e.onBoundsChanged,
      d = e.onClick,
      c = e.onDoubleClick,
      s = e.onDrag,
      u = e.onDragEnd,
      m = e.onDragStart,
      p = e.onMouseDown,
      g = e.onMouseOut,
      v = e.onMouseOver,
      h = e.onMouseUp,
      f = e.onRightClick,
      y = l(T),
      b = y.state,
      C = y.dispatch,
      j = r(""),
      w = j[0],
      O = j[1],
      _ = r(void 0),
      M = _[0],
      N = _[1],
      P = r(n || "rectangle-" + o())[0];

  return i(function () {
    if (void 0 !== b.map) {
      var e = new google.maps.Rectangle(Object.assign({}, a, {
        map: b.map
      }));
      return N(e), O(JSON.stringify(a)), function (e) {
        C({
          type: "add_object",
          object: e,
          id: P
        });
      }(e), function () {
        return C({
          type: "remove_object",
          id: P
        });
      };
    }
  }, [b.map]), D(M, [{
    name: "bounds_changed",
    handler: t
  }, {
    name: "click",
    handler: d
  }, {
    name: "dblclick",
    handler: c
  }, {
    name: "drag",
    handler: s
  }, {
    name: "dragend",
    handler: u
  }, {
    name: "dragstart",
    handler: m
  }, {
    name: "mousedown",
    handler: p
  }, {
    name: "mouseout",
    handler: g
  }, {
    name: "mouseover",
    handler: v
  }, {
    name: "mouseup",
    handler: h
  }, {
    name: "rightclick",
    handler: f
  }]), S(M, a, w, O), null;
};

oe.displayName = "Rectangle";

var te = function te(e) {
  var n = e.id,
      d = e.opts;
  void 0 === d && (d = _);

  var c = e.onPlacesChanged,
      s = e.bindingPosition,
      u = function (e, n) {
    var a = {};

    for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && -1 === n.indexOf(o) && (a[o] = e[o]);
    }

    return a;
  }(e, ["id", "opts", "onPlacesChanged", "bindingPosition"]),
      m = l(T),
      p = m.state,
      g = m.dispatch,
      v = r(void 0),
      h = v[0],
      f = v[1],
      y = r(n || "search-box-" + o())[0],
      b = r(document.createRange().createContextualFragment(a.renderToString(t.createElement("input", Object.assign({
    id: y
  }, u)))).firstElementChild)[0],
      C = r(s),
      j = C[0],
      w = C[1];

  return i(function () {
    if (void 0 !== p.map && void 0 !== p.places) {
      var e = s ? b : document.getElementById(y),
          n = new google.maps.places.SearchBox(e, d);

      if (f(n), g({
        type: "add_object",
        object: n,
        id: y
      }), s) {
        if (s !== j) {
          var a = p.map.controls[google.maps.ControlPosition[j]],
              o = a.getArray();
          a.removeAt(o.findIndex(function (e) {
            return e === b;
          })), w(s);
        }

        p.map.controls[google.maps.ControlPosition[s]].push(e);
      }

      return function () {
        return g({
          type: "remove_object",
          id: y
        });
      };
    }
  }, [p.places, s]), D(h, [{
    name: "places_changed",
    handler: c
  }]), i(function () {
    void 0 !== h && void 0 !== d.bounds && h.setBounds(d.bounds);
  }, [d.bounds]), s ? null : t.createElement("input", Object.assign({
    id: y
  }, u));
};

te.displayName = "SearchBox";

var re = function re(e) {
  return t.createElement(te, Object.assign({}, e));
};

re.displayName = "SearchBox";

var ie = function ie(e) {
  return t.createElement(te, Object.assign({}, e));
};

ie.displayName = "StandaloneSearchBox";

var de = function de(e) {
  var n = e.id,
      a = e.className,
      d = e.style;
  void 0 === d && (d = C);
  var c = e.opts;
  void 0 === c && (c = N);
  var s = e.bindToMap,
      u = e.onCloseClick,
      m = e.onPanoChanged,
      p = e.onPositionChanged,
      g = e.onPovChanged,
      v = e.onResize,
      h = e.onStatusChanged,
      f = e.onVisibleChanged,
      y = e.onZoomChanged,
      b = l(T),
      j = b.state,
      w = b.dispatch,
      O = r(""),
      k = O[0],
      _ = O[1],
      M = r(void 0),
      P = M[0],
      E = M[1],
      x = r(n || (s ? "street-view" : "street-view-" + o()))[0];
  return i(function () {
    if (void 0 !== j.map) {
      var e = new google.maps.StreetViewPanorama(document.getElementById(x), c);
      return E(e), _(JSON.stringify(c)), function (e) {
        w({
          type: "add_object",
          object: e,
          id: x
        });
      }(e), s && j.map.setOptions({
        streetView: e
      }), function () {
        s && j.map && j.map.setOptions({
          streetView: void 0
        }), w({
          type: "remove_object",
          id: x
        });
      };
    }
  }, [j.map]), D(P, [{
    name: "closeclick",
    handler: u
  }, {
    name: "pano_changed",
    handler: m
  }, {
    name: "position_changed",
    handler: p
  }, {
    name: "pov_changed",
    handler: g
  }, {
    name: "resize",
    handler: v
  }, {
    name: "status_changed",
    handler: h
  }, {
    name: "visible_changed",
    handler: f
  }, {
    name: "zoom_changed",
    handler: y
  }]), S(P, c, k, _), t.createElement("div", {
    className: a,
    id: x,
    style: d
  });
};

de.displayName = "BasicStreetView";

var le = function le(e) {
  return t.createElement(de, Object.assign({
    bindToMap: !1
  }, e));
};

le.displayName = "StandaloneStreetView";

var ce = function ce(e) {
  return t.createElement(de, Object.assign({
    bindToMap: !0
  }, e));
};

ce.displayName = "StreetView";

var se = function se(e) {
  return t.createElement(V, {
    type: "traffic",
    opts: e.opts
  });
};

se.displayName = "TrafficLayer";

var ue = function ue(e) {
  return t.createElement(V, {
    type: "transit"
  });
};

ue.displayName = "TransitLayer";
export { B as Autocomplete, A as StandaloneAutocomplete, z as BicyclingLayer, H as Circle, F as CustomControl, U as DrawingManager, G as GroundOverlay, W as HeatMap, q as InfoWindow, Q as KmlLayer, V as Layer, X as MapBox, $ as Marker, ee as OverlayView, ne as Polygon, ae as Polyline, oe as Rectangle, re as SearchBox, ie as StandaloneSearchBox, le as StandaloneStreetView, ce as StreetView, se as TrafficLayer, ue as TransitLayer, Y as withSecurityBounder, E as useGoogleAPI, D as useGoogleListener, I as GoogleMapProvider, T as GoogleMapContext, J as GoogleMapConsumer };